module.exports = __webpack_public_path__ + "media/images/games/k2gender/pink-0718bcf091945bb6b4905f680d126e53.png";